import React, { useEffect, useState } from "react"
import {
  Card,
  CardContent,
  Typography,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Box,
} from "@material-ui/core"
import { useParams } from "react-router-dom"
import getHttpsCallable from "../../utils/getHttpsCallable"

const showBmwRegistrationTracking = 
  getHttpsCallable("admin-showBmwRegistrationTracking")

export default function BmwRegistrationTrackingShow () {
  const params: { id: string } = useParams()
  const date = decodeURIComponent(params.id)
  const [record, setRecord] = useState<any>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    async function fetchData () {
      try {
        const result = await showBmwRegistrationTracking({ date })
        setRecord(result.data)
      } 
      catch (error) {
        console.error("Error fetching BMW registration tracking detail:", error)
      } 
      finally {
        setLoading(false)
      }
    }

    if (date) fetchData()
  }, [date])

  if (loading) {
    return (
      <Box 
        display="flex" 
        justifyContent="center" 
        alignItems="center" 
        height="60vh"
      >
        <CircularProgress />
      </Box>
    )
  }

  if (!record) {
    return <div>No data found for this date.</div>
  }

  // Collect all unique utm_source keys from all categories
  const allUtmSources: string[] = Array.from(
    new Set<string>(
      record
        .categories
        .flatMap((cat: any) => Object.keys(cat.utmBreakdown || {})),
    ),
  )

  return (
    <Card>
      <CardContent>
        <Typography variant="h5" gutterBottom>
          BMW Registration Tracking - {record.date}
        </Typography>

        <Box mb={3}>
          <Typography variant="subtitle1">
            <strong>Total Unique Users:</strong> {record.totalUsers}
          </Typography>
        </Box>

        <Box
          sx={{
            width: "100%",
            overflow: "auto",
            maxHeight: "70vh",
            border: "1px solid #ddd",
            borderRadius: "8px",
          }}
        >
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell><strong>Slide</strong></TableCell>
                <TableCell><strong>Button</strong></TableCell>

                {/* Dynamic UTM source columns */}
                {allUtmSources.map((src: string) => (
                  <TableCell key={src} align="right">
                    <strong>{src}</strong>
                  </TableCell>
                ))}

                <TableCell align="right">
                  <strong>Total</strong>
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {record.categories.map((item: any, index: number) => (
                <TableRow key={index}>
                  <TableCell>{item.category}</TableCell>
                  <TableCell>{item.value}</TableCell>

                  {/* UTM values per source */}
                  {allUtmSources.map((src: string) => (
                    <TableCell key={src} align="right">
                      {item.utmBreakdown?.[src] || 0}
                    </TableCell>
                  ))}

                  <TableCell align="right">
                    {item.total}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </CardContent>
    </Card>
  )
}
